import { render, staticRenderFns } from "./printPage.vue?vue&type=template&id=3667d160&scoped=true"
import script from "./printPage.vue?vue&type=script&lang=js"
export * from "./printPage.vue?vue&type=script&lang=js"
import style0 from "./printPage.vue?vue&type=style&index=0&id=3667d160&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667d160",
  null
  
)

export default component.exports